import { render, staticRenderFns } from "./studentExams.vue?vue&type=template&id=0ba4150a&scoped=true"
import script from "./studentExams.vue?vue&type=script&lang=js"
export * from "./studentExams.vue?vue&type=script&lang=js"
import style0 from "./studentExams.vue?vue&type=style&index=0&id=0ba4150a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4150a",
  null
  
)

export default component.exports